import React, { Component } from "react"
import styled from "styled-components"

import AddtoSlack from "./AddtoSlack"
import HeaderConvo from "./HeaderConvo"

const SectionHeaderWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  max-width: 1600px;

  @media (max-width: 980px) {
  }

  @media (max-width: 768px) {
    text-align: center;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  @media screen and (max-width: 480px) {
    margin-top: -100px;
  }
`

const SectionHeaderContentWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 55%;
  padding-left: 50px;
  max-width: 650px;

  @media (max-width: 980px) {
    width: 70%;
  }

  @media (max-width: 768px) {
    margin-top: -100px;
    padding-left: 0px;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 480px) {
    width: 90%;
  }
`
const SectionHeaderHeadline = styled.h1`margin-bottom: 20px;`

const SectionHeaderCopy = styled.p`
  margin-bottom: 40px;
  @media (max-width: 480px) {
    margin-bottom: 10px;
  }
`

const SectionHeaderContent = props => (
  <SectionHeaderWrapper>
    <HeaderConvo name={props.name} />
    <SectionHeaderContentWrapper>
      <SectionHeaderHeadline>{props.headline}</SectionHeaderHeadline>
      <SectionHeaderCopy>{props.copy}</SectionHeaderCopy>
      <AddtoSlack />
    </SectionHeaderContentWrapper>
  </SectionHeaderWrapper>
)

export default SectionHeaderContent



// WEBPACK FOOTER //
// ./src/components/SectionHeaderContent.js